import { ListSortDirection, Sort } from "../../models/api/sort";
import { CurrencyDTO, CurrencySTO } from "../../models/currencies";
import { BaseApiService } from "../base/base-api.service";

export class CurrenciesApiService extends BaseApiService<CurrencyDTO, CurrencySTO> {
  constructor() {
    super({
      servicePath: "/Currencies",
      loadItemsPath: "/GetCurrencies",
      saveItemsPath: "/SaveCurrencies",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
